document.addEventListener('click', e => {
    const allowedTarget = e.target.closest('.scroll-up');
    if (allowedTarget) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
});